export default {
      id: "facebook-negative-usage",
      viewBox: "0 0 20 20",
      url: "/assets/" + "icons.svg#facebook-negative",
      toString: function () {
        return this.url;
      }
    }